export default __webpack_public_path__ + "static/media/rocket_anim_107.6983c762.png";